<template>
    <div class="page-loading">
        <div class="loader" />
    </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/components/loading.scss" as *;
</style>
